<!-- eslint-disable import/no-mutable-exports -->

<script lang="ts">
import { ConfigProvider as AConfigProvider, Spin as ASpin } from 'ant-design-vue'
import { run } from './invitationCode'
import { themes } from './theme'

export { $d, $t, currentLocale, localePath }

type NuxtApp = ReturnType<typeof useNuxtApp>

let $t: NuxtApp['$i18n']['t']
let $d: NuxtApp['$i18n']['d']
let localePath: ReturnType<typeof useLocalePath>
let currentLocale: NuxtApp['$i18n']['locale']
const antLocale = ref()

function setupProvider(nuxtApp: NuxtApp) {
  $t = nuxtApp.$i18n.t
  $d = nuxtApp.$i18n.d
  localePath = useLocalePath()
  currentLocale = nuxtApp.$i18n.locale
}
</script>

<script setup lang="ts">
// 设置默认Spin
ASpin.setDefaultIndicator({
  indicator: h('i', { class: 'i-svg-spinners:180-ring-with-bg block' }),
})

run()
setupProvider(useNuxtApp())

// 动态加载对应的 antd 语言包
watchEffect(async () => {
  if (currentLocale.value === 'zh') {
    const mod = await import('ant-design-vue/es/locale/zh_CN')
    antLocale.value = mod.default
  }
  else {
    const mod = await import('ant-design-vue/es/locale/en_US')
    antLocale.value = mod.default
  }
})
</script>

<template>
  <AConfigProvider
    :theme="themes"
    :locale="antLocale"
  >
    <slot />
  </AConfigProvider>
</template>
